import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	inject,
	input,
	OnChanges,
	OnDestroy,
	Output,
	signal,
	WritableSignal,
} from '@angular/core';
import { EntityFormConfig } from '../../types';
import { MatTabsModule } from '@angular/material/tabs';
import { InformationTabComponent } from '../information-tab/information-tab.component';

import { TasksTabComponent } from '../tasks-tab/tasks-tab.component';
import { ActivityTabComponent } from '../activity-tab/activity-tab.component';
import {
	ICMMSEntities,
	ICMMSLocation,
} from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import { MatButtonModule } from '@angular/material/button';
import { CMMS_STATUSES } from '@app/pages/cmms/configs/statuses-by-entity';
import { LocationsChipComponent } from '@app/shared/entity-workspace-components/locations-chip/locations-chip.component';
import { EntityWorkspaceActionsComponent } from '../../entity-workspace-actions/entity-workspace-actions.component';
import { EntityTitleComponent } from '@app/shared/entity-workspace-components/entity-title/entity-title.component';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { FilesTabComponent } from '../files-tab/files-tab.component';
import { AssetsTabComponent } from '../assets-tab/assets-tab.component';
import { EntityStatusTextComponent } from '@app/shared/entity-workspace-components/entity-status-text/entity-status-text.component';
import { IWorkOrder } from '@app/domain/cmms-types/workorder-types';
import { AuCloseButtonComponent } from '@app/shared/ui-components/au-close-button/au-close-button.component';
import { NewRightSidebarService } from '@app/layout/new-right-sidebar/services/new-right-sidebar/new-right-sidebar.service';
@Component({
	selector: 'entity-workspace-form',
	imports: [
		MatTabsModule,
		MatButtonModule,
		InformationTabComponent,
		TasksTabComponent,
		ActivityTabComponent,
		EntityWorkspaceActionsComponent,
		FilesTabComponent,
		AssetsTabComponent,
		EntityStatusTextComponent,
		LocationsChipComponent,
		EntityTitleComponent,
		NgxTolgeeModule,
		AuCloseButtonComponent,
	],
	templateUrl: './entity-workspace-form.component.html',
	styleUrls: ['./entity-workspace-form.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityWorkspaceFormComponent implements OnChanges, OnDestroy {
	private readonly sidebarService = inject(NewRightSidebarService);

	initialConfig = input<EntityFormConfig>();
	@Output() saveData = new EventEmitter<ICMMSEntities>();
	statuses: WritableSignal<string[]> = signal(CMMS_STATUSES.WORK_ORDERS);
	config = signal<EntityFormConfig>(this.initialConfig());
	locationAncestry: WritableSignal<ICMMSLocation[]> = signal([]);

	ngOnChanges(): void {
		this.config.set({ ...this.initialConfig() });
	}

	ngOnDestroy(): void {
		this.saveData.emit(this.config().data);
	}

	entityIcon(): string {
		if ('routineData' in this.config().data) {
			const workOrder = this.config().data as IWorkOrder;
			return workOrder.routineData ? 'routine' : 'work_order';
		}
		switch (this.config().entityType) {
			case 'WO':
				return 'work_order';
			case 'REQUEST':
				return 'request';
		}
	}

	// Input should be something like Partial<ICMMSEntities>, but compiler is not happy with that
	// Could be an indication that the design is not correct
	updateData(data: any) {
		this.config.update(value => ({
			...value,
			data: { ...value.data, ...data },
		}));
		this.saveData.emit(this.config().data);
	}

	protected closeSidebar() {
		this.sidebarService.close();
	}
}
